import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useClickAway, useMedia } from 'react-use';
import { NavMainProps, NavItem, NavItemBase } from './types/NavMain.types';
import RenderDelay from '../RenderDelay';
import BaseBtn from '../BaseBtn';
import { LinkField } from '@sitecore-jss/sitecore-jss-react';
import { useTranslation } from 'react-i18next';
import './NavMain.scss';





const NavMain = ({ data, navMainOpen, onClose }: NavMainProps) => {
  const { t } = useTranslation();

  const [firstLevelActive, firstLevelActiveSet] = useState<
    string | undefined
  >();
  const [secondLevelActive, secondLevelActiveSet] = useState<
    string | undefined
  >();
  const [thirdLevelActive, thirdLevelActiveSet] = useState<
    string | undefined
  >();

  const [skipAnimation, setSkipAnimation] = useState<boolean>(false);

  useEffect(() => {
    if (!firstLevelActive) {
      setSkipAnimation(false);
    } else {
      setTimeout(() => {
        setSkipAnimation(true);
      }, 500);
    }
  }, [firstLevelActive]);



  const isWide = useMedia('(min-width: 1200px)');

  const [hoverMainItem, setHoverMainItem] = useState('');

  const getFatherTitle: (levelTitle: string) => string = useCallback(
    (levelTitle) => {
      let father = '';

      data.forEach((l1) => {
        const match = l1?.subSectionItems.find((l2) =>
          l2?.subSectionItems?.find((l3) => l3?.title?.value === levelTitle)
        );
        if (match) father = match?.title?.value as string;
      });

      return father;
    },
    []
  );


  
  const renderArrowLeft = useCallback(
    (item: NavItem, level: number) => {
      if (
        (level === 0 && item.title.value === firstLevelActive) ||
        (level === 1 && item.title.value === secondLevelActive) ||
        (level === 2 && item.title.value === thirdLevelActive)
      ) {
        return null;
      }
      if (
        (!secondLevelActive && item.subSectionItems) ||
        (!thirdLevelActive && item.subSectionItems)
      ) {
        return <i className="arrow-right arrow__white mr-5" />;
      }
      return null;
    },
    [firstLevelActive, secondLevelActive, thirdLevelActive]
  );

  const renderItem = useCallback(
    (item: NavItem, level: number) => {
      const isSubNav =
        thirdLevelActive === item.title.value ||
        secondLevelActive === item.title.value ||
        firstLevelActive === item.title.value;

      let wrapClass = isWide ? '' : 'NavMain__itemWrap';
      if (
        (!isWide && level === 0 && secondLevelActive) ||
        (level === 1 && thirdLevelActive)
      ) {
        wrapClass = 'NavMain__itemHidden';
      }

      if (isSubNav) {
        wrapClass += ' NavMain__SubNav';
      }

      let itemClass =
        level === 0
          ? 'NavMain__UlFirstLevelItem NavMain__Item ga4-click-ui-menu'
          : 'NavMain__Item ga4-click-ui-menu';
      if (
        level === 0 &&
        firstLevelActive &&
        firstLevelActive !== item.title.value
      ) {
        itemClass = `${itemClass} NavMain__itemDisabled`;
      }
      if (
        (!isWide && level === 0 && secondLevelActive) ||
        (level === 1 && thirdLevelActive)
      ) {
        itemClass = 'NavMain__itemHidden';
      }
      if (level === 1) {
        itemClass = `${itemClass} NavMain__SecondLevelItem`;
        if (
          (secondLevelActive && secondLevelActive !== item.title.value) ||
          thirdLevelActive
        ) {
          itemClass = 'NavMain__itemHidden';
        }
      }
      if (level === 2) {
        itemClass = `${itemClass} NavMain__SecondLevelItem ga4-click-ui-menu`;
        if (thirdLevelActive && thirdLevelActive !== item.title.value) {
          itemClass = 'NavMain__itemHidden';
        }
      }

      if (
        item.link &&
        (item?.subSectionItems?.length === 0 || !item?.subSectionItems)
      ) {
        return (
          <a
            className={itemClass}
            href={
              [item.link as unknown as LinkField][0].value?.href
                ? [item.link as unknown as LinkField][0].value?.href
                : item.link.value
            }
            target={item.link.linktype === 'external' ? '_blank' : '_self'}
            style={
              hoverMainItem.length === 0 ||
              level > 0 ||
              firstLevelActive ||
              !isWide
                ? {}
                : {
                    opacity: hoverMainItem === item?.title?.value ? 1 : 0.5,
                  }
            }
            onMouseEnter={() => {
              if (level > 0) return;
              setHoverMainItem(item?.title?.value as string);
            }}
            onMouseLeave={() => {
              if (level > 0) return;
              setHoverMainItem('');
            }}
          >
            <span className='ga4-click-ui-menu'>
              {(item.icon?.value as string)?.length > 0 && (
                <span
                  className={`icon ${item.icon.value} NavMain__NavMainIcon`}
                />
              )}
              {item.title.value}

              {level !== 0 &&
                ([item.link as unknown as LinkField][0]?.value?.linktype ===
                  'external' ||
                  item.link.linktype === 'external') && (
                  <span
                    className={`NavMain__NavMainTrailingIcon icon icon-go_to`}
                  />
                )}
            </span>
          </a>
        );
      }

      return (
        <div className={wrapClass}>
          {!isWide && isSubNav && !thirdLevelActive && back({ level })}
          {!isWide &&
            thirdLevelActive &&
            thirdLevelActive === item.title.value &&
            back({ level, prevLevelName: item.title.value as string })}
          <span
            className={itemClass}
            onClick={() => onPress(level, item.title.value as string)}
            style={
              hoverMainItem.length === 0 ||
              level > 0 ||
              firstLevelActive ||
              !isWide
                ? {}
                : {
                    opacity: hoverMainItem === item?.title?.value ? 1 : 0.5,
                  }
            }
            onMouseEnter={() => {
              if (level > 0) return;
              setHoverMainItem(item?.title?.value as string);
            }}
            onMouseLeave={() => {
              if (level > 0) return;
              setHoverMainItem('');
            }}
          >
            <span className="d-xl-inline d-flex">
              {(item?.icon?.value as string)?.length > 0 && (
                <span
                  className={`icon ${item.icon.value} NavMain__NavMainIcon ga4-click-ui-menu`}
                />
              )}
              <span className={item.icon ? 'NavMain__span_icon_title ga4-click-ui-menu' : 'ga4-click-ui-menu'}>
                {item.title.value}
              </span>
            </span>
            {renderArrowLeft(item, level)}
          </span>
        </div>
      );
    },
    [
      firstLevelActive,
      secondLevelActive,
      thirdLevelActive,
      hoverMainItem,
      isWide,
    ]
  );

  const renderButtons = useCallback((buttons: NavItemBase[]) => {
    return (
      <div className="NavMain__NavMainButtons ga4-click-ui-menu">
        {buttons.map((button: NavItemBase, idx) => {
          return (
            <BaseBtn
              key={idx}
              text={button?.title}
              url={button?.link?.value as string}
              isRed
              icon={button?.icon?.value as string}
            />
          );
        })}
      </div>
    );
  }, []);

  interface CustomMouseEvent extends MouseEvent {
    path: Element[];
  }

  const navRef = useRef(null);
  useClickAway(navRef, (e: CustomMouseEvent) => {
    if (e.path?.[5]?.classList?.contains('NavMain__Wrapper') || !isWide) return;
    onPress(0);
  });

  const renderNode: (options: {
    item: NavItem;
    index: number;
    level?: number;
    navHistory?: string[];
  }) => JSX.Element = useCallback(
    ({ item, index, level = 0, navHistory = [] }) => {
      if (level !== 0 && !firstLevelActive) {
        return <div key={index + level}></div>;
      }

      const updatedNavHistory = [...navHistory, item.title.value as string];

      const shouldRenderBackButton =
        updatedNavHistory.filter((i) => i === item.title.value).length === 1;

      const Tag = level === 0 ? 'div' : 'li';

      let levelClass =
        level === 0
          ? `NavMain__SecondLevel ${
              skipAnimation ? 'NavMain__SecondLevelActive--skip' : ''
            }`
          : level === 1
          ? `NavMain__ThirdLevel ${
              thirdLevelActive ? 'NavMain__ThirdLevel--closed' : ''
            } ${skipAnimation ? 'NavMain__SecondLevelActive--skip' : ''}`
          : `NavMain__ForthLevel ${
              skipAnimation ? 'NavMain__SecondLevelActive--skip' : ''
            }`;
      if (
        level === 0 &&
        firstLevelActive === item.title.value &&
        item.title.value !== undefined
      ) {
        levelClass = `${levelClass} NavMain__SecondLevelActive`;
      }
      if (
        level === 1 &&
        secondLevelActive === item.title.value
        // !thirdLevelActive
      ) {
        levelClass = `${levelClass} NavMain__ThirdLevelActive`;
      }
      if (level === 2 && thirdLevelActive === item.title.value) {
        levelClass = `${levelClass} NavMain__ForthLevelActive`;
      }

      return (
        <Tag key={index + level} className="NavMain__Wrapper">
          {((shouldRenderBackButton &&
            isWide &&
            secondLevelActive &&
            secondLevelActive === item.title.value) ||
            (thirdLevelActive && thirdLevelActive === item.title.value)) &&
            back({
              level: thirdLevelActive && !isWide ? level - 1 : level,
              prevLevelName:
                thirdLevelActive &&
                thirdLevelActive === item.title.value &&
                isWide
                  ? item.title.value
                  : undefined,
            })}
          <div
            className={
              thirdLevelActive && thirdLevelActive === item.title.value
                ? 'NavMain__Container_padding'
                : ''
            }
          >
            {renderItem(item, level)}
            <div
              className={levelClass}
              ref={
                level === 0 &&
                firstLevelActive === item.title.value &&
                item.title.value !== undefined
                  ? navRef
                  : null
              }
            >
              {level === 0 && (
                <a
                  className="icon icon-close d-none d-xl-block NavMain__Close ga4-click-ui-menu"
                  onClick={() => onPress(0)}
                />
              )}
              {item.subSectionItems && (
                <ul>
                  {item.subSectionItems.map((child: NavItem, index) => {
                    return renderNode({
                      item: child,
                      index,
                      level: level + 1,
                      navHistory: updatedNavHistory,
                    });
                  })}
                </ul>
              )}
              {item.sectionButton &&
                !secondLevelActive &&
                renderButtons(item.sectionButton)}
            </div>
          </div>
        </Tag>
      );
    },
    [
      data,
      firstLevelActive,
      secondLevelActive,
      thirdLevelActive,
      skipAnimation,
      hoverMainItem,
      isWide,
    ]
  );

  const onPress = useCallback(
    (level: number, label?: string) => {
      if (level === 0) {
        firstLevelActiveSet(label);
        secondLevelActiveSet(undefined);
        thirdLevelActiveSet(undefined);
      } else if (level === 1) {
        secondLevelActiveSet(label);
        thirdLevelActiveSet(undefined);
      } else if (level === 2) {
        thirdLevelActiveSet(label);
      } else {
        firstLevelActiveSet(undefined);
        secondLevelActiveSet(undefined);
        thirdLevelActiveSet(undefined);
      }
    },
    [renderNode]
  );

  const back: (options: {
    level: number;
    prevLevelName?: string;
  }) => JSX.Element = useCallback(
    ({ level, prevLevelName = '' }) => {
      return (
        <a
          className="NavMain__Back arrow-left arrow__white ga4-click-ui-menu"
          onClick={() => onPress(level)}
        >
          <b>
            {prevLevelName
              ? `${t('BackTo')} ${getFatherTitle(prevLevelName)}`
              : t('Back')}
          </b>
        </a>
      );
    },
    [onPress]
  );

  const navMainClass = useMemo(() => {
    let myClass = firstLevelActive ? 'NavMain NavMain--Open' : 'NavMain';
    if (navMainOpen) {
      myClass = `${myClass} NavMain--MobileOpen`;
    }
    return myClass;
  }, [navMainOpen, firstLevelActive]);

  const navMainClassBG = useMemo(() => {
    let myClass = firstLevelActive ? 'NavMainBG NavMainBG--Open' : 'NavMainBG';
    if (navMainOpen) {
      myClass = `${myClass} NavMainBG--MobileOpen`;
    }
    return myClass;
  }, [navMainOpen, firstLevelActive]);

  const [shouldRender, setShouldRender] = useState(null);
  useEffect(() => {
    if (navMainOpen || isWide) {
      setShouldRender(true);
    }
  }, [navMainOpen, isWide]);
  let contesto = this
  const  handleEvent = (event) => {
    if (event.type === "mousedown") {
      //alert('mosedow '+event.type)
       } else {
       // alert('moseup '+event.type)
       }
   }

  return (
    <>
      {shouldRender && (
        <nav  id="main-nav" className={navMainClass} >
          <div  className={navMainClassBG} onTouchStart={() => onClose()}></div>
          <a
            className="icon icon-close  d-xl-none NavMain__Close ga4-click-ui-menu"
            onClick={() => onClose()}
          />
          {data && (
            <ul className="NavMain__UlFirstLevel">
              <RenderDelay
                shouldRender={true}
                transitionDuration={200}
                tag="li"
              >
                {data.map((item: NavItem, index) => {
                  return renderNode({ item, index });
                })}
              </RenderDelay>
            </ul>
          )}
        </nav>
      )}
    </>
  );
};

export default NavMain;
